<template>
  <div @click="cahngeRoute()" class="base-back-button">
    <span class="arrow-wrapper"
      ><img
        :src="require('@/assets/images/fanclub/leaders_arrow.png')"
        alt="arrow_gray"
        :style="{ width: size + 'vh', height: size + 'vh' }"
    /></span>
    <p :style="{ color: textColor }">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "戻る"
    },
    size: {
      type: Number,
      default: 2
    },
    route: {
      type: String,
      default: "/"
    },
    textColor: {
      type: String,
      default: "rgb(64, 64, 64)"
    }
  },
  methods: {
    cahngeRoute() {
      this.$router.push(this.route);
    }
  }
};
</script>

<style lang="css" scoped>
.base-back-button {
  display: flex;
  align-items: center;
}
.arrow-wrapper{
  display: flex;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseBackButton.vue